import { reduce } from 'lodash';
const moment = require('moment');
import { Moment } from 'moment';
import { ReportCalc } from '../../../services/report.class';
import { transpile } from 'typescript';
interface Report {
  type: string;
  startDate: Moment;
  endDate: Moment;
  cashDeskTotal: number;
  receiptTotal: number;
  posTotal: number;
  cashMoneyTotal: number;
  cashTotal: number;
  deposit: number;
  cashMoneyEndOfDay: number;
  o: number;
  note: string;
}
export default class MonthlyReportController {
  loadingReports = false;
  list = [];
  reports: Report[];
  selectedShop;
  selectedMonth;
  daysOfMonth = [];
  customExec: String = null;
  /*@ngInject*/
  constructor(private DailyReport, private Configurations, private $http) {
    // console.log('constr');
    this.$onInit();
  }

  $onInit() {
    // console.log('init');
    var vm = this;
    this.Configurations.query({ active: true }, ([config]) => {
      if (config && config.fileMonthlyCashDesk) {
        vm.$http.get(config.fileMonthlyCashDesk).then(
          function(data) {
            vm.customExec = data.data;
          },
          function(error) {
            alert('error');
          }
        );
      }
    });
  }
  shopSelected(shop, month) {
    this.loadingReports = true;
    this.selectedShop = shop;
    this.selectedMonth = month;
    var startMonth = moment(month)
      .local()
      .startOf('month')
      .subtract(1, 'weeks')
      .format('YYYY-MM-DD');
    var endMonth = moment(month)
      .local()
      .endOf('month')
      .format('YYYY-MM-DD');
    // console.log('month', month);
    this.list = [];
    this.reports = [];
    this.DailyReport.query({ id: shop._id, endMonth, startMonth }, result => {
      this.list = result;
      this.reports = this.list
        .map((e, index) => {
          // debugger;
          var calc = new ReportCalc(e, shop);
          var exec = function(list, index, e, calc) {
            let startRef = index > 0 ? list[index - 1] : e;
            let cashDeskTotal = startRef.bills + startRef.coins;
            let cashMoneyTotal = e.totalReceipts - e.totalPos;
            let cashTotal = e.bills + e.coins + (e.totalReceipts - e.totalPos);
            let cashMoneyEndOfDay = e.bills + e.coins;
            return {
              type: 'report',
              startDate: e.date,
              endDate: e.date,
              cashDeskTotal,
              receiptTotal: calc.getTotal(),
              posTotal: e.totalPos,
              cashMoneyTotal,
              cashTotal,
              deposit: e.deposit,
              cashMoneyEndOfDay,
              o: e.o || 0,
              note: e.note
            };
          };
          if (this.customExec) {
            eval(this.customExec.toString());
          }
          return exec(result, index, e, calc);
        })
        .filter(e => e.startDate > month);
      // console.log('reports calc', this.reports);
      this.initDays(month);
      this.loadingReports = false;
    });
  }

  initDays(month) {
    this.daysOfMonth = [];
    var lastReport = this.reports[this.reports.length - 1];
    var lastDate = moment(lastReport.startDate)
      .local()
      .add(2, 'days');
    var lastWasForLength = false;
    for (
      var day = moment(month)
        .local()
        .startOf('month')
        // is required because ng-repeat skips the first element for some reason
        .subtract(1, 'days');
      day.isBefore(lastDate);
      day.add(1, 'days')
    ) {
      if (
        this.reports.find(r => r.startDate === day.format('YYYY-MM-DD')) ||
        (this.daysOfMonth.length > 0 && !lastWasForLength)
      ) {
        // using moment(day) to create a new object
        this.daysOfMonth.push(moment(day).startOf('day'));
        if (this.daysOfMonth.length == 1) {
          // first day is replicated because ng-repeat skips the first element for some reason
          this.daysOfMonth.push(moment(day).startOf('day'));
        }
      }
      // lastWasForLength =
      //   this.daysOfMonth.length > 0 &&
      //   !this.reports.find(r => r.startDate === day.format('YYYY-MM-DD'));
    }
  }
  getReportFor(day) {
    if (this.reports.length <= 0) {
      return null;
    }
    var result = this.reports.find(e => day.isSame(e.startDate));
    console.log(result);
    if (!result) {
      var total: Report = {
        type: 'total',
        startDate: moment(day),
        endDate: moment(day),
        cashDeskTotal: 0,
        receiptTotal: 0,
        posTotal: 0,
        cashMoneyTotal: 0,
        cashTotal: 0,
        deposit: 0,
        cashMoneyEndOfDay: 0,
        o: 0,
        note: ''
      };
      // console.log(
      //   'report for date',
      //   day.format('YYYY-MM-DD'),
      //   'not found, calculating total....'
      // );
      var found = false;
      for (
        var date = moment(day).subtract(1, 'days');
        !!this.reports.find(e => date.isSame(e.startDate));
        date.subtract(1, 'days')
      ) {
        var report = this.reports.find(e => date.isSame(e.startDate));
        // console.log(
        //   'report for date',
        //   date.format('YYYY-MM-DD'),
        //   'not found, calculating total.... 2'
        // );
        if (report) {
          found = true;
          total.endDate = moment(report.startDate);
          total.cashDeskTotal += report.cashDeskTotal;
          total.receiptTotal += report.receiptTotal;
          total.posTotal += report.posTotal;
          total.cashMoneyTotal += report.cashMoneyTotal;
          total.cashTotal += report.cashTotal;
          total.deposit += report.deposit;
          total.cashMoneyEndOfDay += report.cashMoneyEndOfDay;
        }
      }

      return found ? total : { type: 'report', day };
    }
    return result;
  }
  getGrandTotal() {
    var grandTotal: Report = {
      type: 'grandTotal',
      startDate: moment(),
      endDate: moment(),
      cashDeskTotal: 0,
      receiptTotal: 0,
      posTotal: 0,
      cashMoneyTotal: 0,
      cashTotal: 0,
      deposit: 0,
      cashMoneyEndOfDay: 0,
      o: 0,
      note: 'grand total'
    };
    return reduce(
      this.reports,
      (total: Report, report) => {
        return {
          type: total.type,
          startDate: total.startDate,
          endDate: total.endDate,
          receiptTotal: total.receiptTotal + report.receiptTotal,
          posTotal: total.posTotal + report.posTotal,
          deposit: total.deposit + report.deposit,
          cashMoneyEndOfDay: total.cashMoneyEndOfDay + report.cashMoneyEndOfDay
        };
      },
      grandTotal
    );
  }
  toggleWithdrawn(day) {
    console.log(day);
    this.DailyReport.toggleWithdrawn(
      { id: day._id },
      res => {
        console.log('save ok', res, day);
        day = res;
      },
      err => {
        console.error('err', err);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./client/app/manager/monthlyReport/monthlyReport.controller.ts